












import {Component, Prop, Vue} from 'vue-property-decorator'
import OptionSelector from "@/components/OptionSelector/OptionSelector.vue";

@Component({
    components: {OptionSelector}
})
export default class CategoryOptionSelector extends Vue {

    private onChange(id: number): void {
        if (id == 1) this.$emit("selectEdit");
        if (id == 2) this.$emit("selectDelete");
    }
}
